<template>
    <div>
        <div class="header page-header">
            <div>IMPORT</div>
            <p>Import (#{{this.$route.params.id}})</p>
        </div>
        <div>
            <div>
                <div class="tabs__header">
                    <div class="tabs">
                        <router-link :to="`/dashboard/imports/${this.$route.params.id}`">Invoices</router-link>
                        <router-link :to="`/dashboard/imports/${this.$route.params.id}/validation`">Validation Report</router-link>
                    </div>
                    <div>
                        <Button class="btn btn__primary" text="Export To Excel" @on-click="exportToExcel"/>
                    </div>
                </div>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
  import Button from '../partials/Button.vue'

  export default {
    name: 'ImportDetails',
    created: function () {
      document.title = 'Import Invoices | PayGate Invoice'
    },
    components: {
      Button
    },
    methods: {
      exportToExcel () {

      }
    }
  }
</script>

<style lang="scss" scoped>
.tabs {
  font-family: Montserrat-SemiBold;
}

</style>